import { z } from "zod";
export const accessRequestSchema = z
    .object({
    interest: z.enum(["lite", "pro", "dedicated"]).optional(),
    building: z.string().trim().max(1000).optional(),
})
    .strict();
export const accessRequestResponseSchema = z.object({ created: z.boolean() });
//# sourceMappingURL=access-request.js.map